import MatchHeight from "matchheight";
import $ from 'jquery';
import Swiper from 'swiper/bundle';

function slideMenu() {
    const slideMenu_switch = document.getElementById('slideMenu_switch');
    const slideMenu = document.getElementById('slideMenu');


    if (slideMenu_switch){
        slideMenu_switch.addEventListener('click', function () {
        let slideMenu_duration = 300;

        if (!slideMenu.classList.contains('open')) {


            slideMenu_switch.classList.add('open');
            slideMenu_switch.style.setProperty('pointer-events', 'none')

            slideMenu.classList.add('open');

            setTimeout(function () {
                slideMenu.classList.add('open');

                slideMenu_switch.style.setProperty('pointer-events', null)
            }, slideMenu_duration)


        } else {


            slideMenu_switch.style.setProperty('pointer-events', 'none')


            slideMenu.classList.remove('open');
            slideMenu_switch.classList.remove('open');

            setTimeout(function () {
                slideMenu_switch.style.setProperty('pointer-events', null)
            }, slideMenu_duration)


        }
    })
    }
}


const headerMenu = document.getElementById('header_menu');

function setHeader(){
    let scrollTop = window.pageYOffset;

    if (matchMedia('min-width:769px')){
        if (scrollTop >= 105){
            headerMenu.classList.add('fixed');
        } else {
            headerMenu.classList.remove('fixed');
        }
    }
}

function headerFixed() {

    if (headerMenu){


        window.addEventListener('scroll',function () {
            setHeader();
        })

        setHeader();
    }

}

function machineAcd(){
    const acdBody = document.getElementsByClassName('machineAcd');

    if(acdBody.length > 0){
        for (let i = 0,len = acdBody.length; i < len; i++){
            let initialItem = acdBody[i].children.item(0);
            console.log(initialItem)
            let initialHeight = initialItem.clientHeight;

            acdBody[i].style.setProperty('height',initialHeight + 'px')
        }

        (function () {
            const btn = document.querySelectorAll('[data-tgtAcd]');

            for (let i = 0,len = btn.length; i < len; i++){
                btn[i].addEventListener('click',function () {
                    let tgtId = btn[i].getAttribute('data-tgtAcd');
                    let tgtAcd = document.getElementById(tgtId);

                    tgtAcd.style.setProperty('height',tgtAcd.scrollHeight + 'px');

                    btn[i].remove();
                })
            }
        }())
    }
}

function faqAcd() {
    const item = document.getElementsByClassName('faq_list_item');

    if (item.length > 0) {
        for (let i = 0, len = item.length; i < len; i++) {

            let itemA = item[i].getElementsByClassName('faq_list_a')[0];

            item[i].addEventListener('click', function () {
                if (!itemA.classList.contains('open')) {
                    itemA.style.setProperty('height', itemA.scrollHeight + 'px');
                    itemA.classList.add('open');
                }
                else{
                    itemA.style.setProperty('height', null);
                    itemA.classList.remove('open');
                }
            })

        }
    }
}

function priceSlider(){

    let sliders = document.querySelectorAll('.priceSlider');

    sliders.forEach((slider,i)=>{
        let newClass = 'priceSlider'+i;
        slider.parentElement.classList.add(newClass);

        let priceSlider = new Swiper('.'+newClass + ' .swiper' , {
            slidesPerView: 1,
            centeredSlides: true,
            loop: false,
            spaceBetween: 20,
            pagination: {
                el: '.'+newClass + ' .swiper-pagination',
                type: 'bullets',
            },
            navigation: {
                nextEl: '.'+newClass + ' .swiper-button-next',
                prevEl: '.'+newClass + ' .swiper-button-prev',
            },
        })
        priceSlider.constructor;
    })
}

//よくある質問：アンカーリンク先のidに連番の数字を付与
$(function(){
    $('div.unker').each(function(i){
        $(this).attr('id','unker' + (i+1));
    });
});

//スムーススクロール
$('a[href^="#"]').on('click', function () {
    var speed = 500;
    var href = $(this).attr('href');
    var target = $(href == '#' || href == "" ? 'html' : href);
    var position = target.offset().top;

    $('body,html').animate({
        scrollTop: position
    }, speed, 'swing');
    return false;
});

slideMenu();
headerFixed();
faqAcd();
MatchHeight.init();
priceSlider();

if ( window.matchMedia('(max-width: 768px)').matches ){
    machineAcd();
}